import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";

import { BaseDataService, HttpResponsesHandlersFactory } from "@bbwt/modules/data-service";
import { IQuerySchema, IViewMetadata, IQueryPageRequest, IQueryAggregationsRequest } from "../../core/reporting-models";
import { IQueryVariables } from "@main/reporting.v3/core/variables/variable-models";
import { DashboardContextService } from "@main/reporting.v3/dashboard/api/dashboard-context.service";


@Injectable()
export class WidgetGridDataService extends BaseDataService {
    private dashboardContext = inject(DashboardContextService, { optional: true });

    readonly url = "api/reporting3/widget/grid/data";

    constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
        super(http, handlersFactory);
    }

    getDataRows(querySourceId: string, queryPageRequest?: IQueryPageRequest): Promise<any[]> {
        queryPageRequest ??= <IQueryPageRequest>{ gridSettings: {}, queryVariables: { variables: [] } };

        const headers: HttpHeaders = this.dashboardContext?.dashboardHeader;
        return this.handle(this.http.post<any[]>(`${this.url}/${querySourceId}/query-data`, queryPageRequest, { headers }));
    }

    getDataRowsCount(querySourceId: string, queryVariables?: IQueryVariables): Promise<number> {
        queryVariables ??= <IQueryVariables>{ variables: [] };

        const headers: HttpHeaders = this.dashboardContext?.dashboardHeader;
        return this.handle(this.http.post<number>(`${this.url}/${querySourceId}/query-data-count`, queryVariables, { headers }));
    }

    getAggregations(querySourceId: string, queryAggregationsRequest: IQueryAggregationsRequest): Promise<any> {
        queryAggregationsRequest ??= <IQueryAggregationsRequest>{
            queryVariables: <IQueryVariables>{ variables: [] },
            aggregations: []
        };

        const headers: HttpHeaders = this.dashboardContext?.dashboardHeader;
        return this.handleRequest(this.http.post<any>(`${this.url}/${querySourceId}/query-data-aggregations`, queryAggregationsRequest, { headers }));
    }

    getQuerySchema(querySourceId: string): Promise<IQuerySchema> {
        const headers: HttpHeaders = this.dashboardContext?.dashboardHeader;
        return this.handle(this.http.get<IQuerySchema>(`${this.url}/${querySourceId}/query-schema`, { headers }));
    }

    getViewMetadata(widgetSourceId: string): Promise<IViewMetadata> {
        const headers: HttpHeaders = this.dashboardContext?.dashboardHeader;
        return this.handleRequest(this.http.get<IViewMetadata>(`${this.url}/${widgetSourceId}/view-metadata`, { headers }));
    }
}